module.exports = __webpack_public_path__ + "img/mountain.976d7294.svg";